import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnersComponent } from './partners.component';
import { PartnersRoutingModule } from './partners-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskModule } from 'ngx-mask';
import { AppMaterialModule } from 'src/app/app-material.module';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { CustomPipeModule } from 'src/app/shared/pipes/custom-pipes.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { TablePartnersComponent } from './components/table-partners/table-partners.component';
import { PartnerConfigComponent } from './modals/partner-config/partner-config.component';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL,
};

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    FormsModule,
    PartnersRoutingModule,
    CustomPipeModule,
    AppMaterialModule,
    NgxMaskModule.forChild(),
    DirectivesModule,
  ],
  declarations: [
    PartnersComponent,
    TablePartnersComponent,
    PartnerConfigComponent,
  ],
})
export class PartnersModule {}
